const paths = {
  main: '/sales',
  chat: '/sales/chat/:id(\\d+)',
  detail: '/sales/:id(\\d+)',
  comment: '/sales/comment/:id(\\d+)',
};

export default paths;
